const variants = {
  primary: "bg-app-brand text-white hover:bg-app-brand-dark focus-visible:ring-app-brand/35",
  secondary: "bg-app-teal text-white hover:bg-app-teal-dark focus-visible:ring-app-teal/30",
  success:
    "border border-[#1ea34f] bg-[#22c55e] text-white hover:bg-[#1ea34f] focus-visible:ring-[rgba(34,197,94,0.35)]",
  ghost: "bg-transparent text-app-ink border border-app-line hover:bg-white focus-visible:ring-app-ink/20",
  danger: "bg-app-danger text-white hover:bg-red-700 focus-visible:ring-red-300"
};

function Button({ variant = "primary", className = "", children, ...props }) {
  const buttonClass = [
    "inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-55",
    variants[variant],
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={buttonClass} {...props}>
      {children}
    </button>
  );
}

export default Button;
